import { PASSWORD_MIN_ALLOWED_LENGTH } from "@finway-group/shared/lib/consts/common"
import { checkIfStringContainsSpecialCharacters } from "@finway-group/shared/lib/utils/common"
import { FormInstance, type Rule } from "antd/lib/form"

import i18n from "Shared/locales/i18n"

export const createLoginPasswordRules = (): Array<Rule> => [
    { required: true, message: i18n.t("validation:required"), validateTrigger: "onChange" },
    { min: PASSWORD_MIN_ALLOWED_LENGTH, message: i18n.t("validation:min.string", { min: PASSWORD_MIN_ALLOWED_LENGTH }), validateTrigger: "onSubmit" },
]

export const createPasswordRules = (formInstance: FormInstance) => ({
    password: [
        createLoginPasswordRules(),
        { max: 100, message: i18n.t("validation:max.string", { max: 100 }), validateTrigger: "onChange" },
        {
            validator: (_rule, value: string) => {
                const hasLeadingOrTrailingSpaces = value.trim() !== value
                if (hasLeadingOrTrailingSpaces) {
                    return Promise.reject(new Error(i18n.t("validation:password.password_has_leading_or_trailing_spaces")))
                }
                return Promise.resolve()
            },
            validateTrigger: "onChange",
        },
        {
            validator: (_rule, value: string) => {
                const passwordDoesNotHaveSpecialCharacters = !checkIfStringContainsSpecialCharacters(value)
                if (passwordDoesNotHaveSpecialCharacters) {
                    return Promise.reject(new Error(i18n.t("validation:password.password_must_have_at_least_one_special_symbol")))
                }
                return Promise.resolve()
            },
            validateTrigger: "onSubmit",
        },
    ] as Array<Rule>,
    confirmPassword: [
        { required: true, message: i18n.t("validation:required"), validateTrigger: "onChange" },
        { min: PASSWORD_MIN_ALLOWED_LENGTH, message: i18n.t("validation:min.string", { min: PASSWORD_MIN_ALLOWED_LENGTH }), validateTrigger: "onSubmit" },
        { max: 100, message: i18n.t("validation:max.string", { max: 100 }), validateTrigger: "onChange" },
        {
            validator: (_rule, value: string) => {
                if (value !== formInstance.getFieldValue("password")) {
                    return Promise.reject(new Error(i18n.t("validation:password.notmatching")))
                }

                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
})
